import React, { useEffect, useState } from "react";
import Row from "../../components/Row";
import Column from "../../components/Column";
import TitleUnderlined from "../../components/TitleUnderlined";
import Button from "../../components/Button";
import Form from "../../components/Form";
import { useNavigate } from 'react-router-dom';
import { RoutesWeb } from "../../tools/RoutesWeb";
import APIInterface from "../../tools/APIInterface";
require('../../style/views/loginView.scss');

const LoginAdminView = () => {
    const token = localStorage.getItem('tokenAdmin');
    const [data, setData] = useState({username: null, password: null});
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingLogin, setIsLoadingLogin] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if(token) {
            navigate(RoutesWeb.ADMIN_DASHBOARD)
        }
    })

    const handleSubmit = (e) => {
        if(!isLoadingLogin){
            setIsLoadingLogin(true);
            APIInterface.login(data)
            .then((response) => {
                localStorage.setItem('tokenAdmin', response.data.token);
                localStorage.setItem('userAdmin', response.data.user.name);
                navigate(RoutesWeb.ADMIN_DASHBOARD);
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
            });
        }
    }

    const handleData = (e) => {
        let newData = data;
        newData[e.target.name] = e.target.value;
        setData(newData);
    }
    return(
        <div className="pt-5" id="loginView">
            <br />
            <br />
            <Row>
                <Column className="col-md-6">
                    <TitleUnderlined>Iniciar <span className="embercom_overlined">Sesión</span></TitleUnderlined>
                    <br />
                    <br />
                    <p>Inicia tu sesión como administrador.</p>
                    <Form submitCallback={handleSubmit} isLoadingCallback={(isLoading) => {
                        setIsLoading(isLoading);
                    }}>
                        <div className="form-group">
                            <label htmlFor="email">Usuario</label>
                            <input type="email" required id="email" name="email" className="form-control" onChange={handleData} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">Contraseña</label>
                            <input type="password" required id="password" name="password" className="form-control" onChange={handleData} />
                        </div>
                        <br />
                        <br />
                        <Button>
                            Iniciar sesión 
                            {isLoadingLogin || isLoading ?
                                <div className="spinner-border" role="status" style={{height: '15px',
                                    width: '15px',
                                    fontSize: '10px',
                                    marginLeft: '10px'}}>
                                    <span className="sr-only"></span>
                                </div>
                            :
                                <img src={require('../../assets/arrow_next.png')} alt="arrowNext" style={{marginLeft: '2rem'}} />
                            }
                        </Button>
                    </Form>
                </Column>
                <Column className="col-md-6 d-flex justify-content-center align-items-start">
                    <img src={require('../../assets/img4.png')} alt="Img" style={{width: '100%', maxWidth: '430px'}} />
                </Column>
            </Row>
        </div>
    )
}

export default LoginAdminView;